// extracted by mini-css-extract-plugin
export default {"mb12":"Certificate_mb12__t-lPc","certificateImgDiv":"Certificate_certificateImgDiv__nFcb5","MiddleContent":"Certificate_MiddleContent__dhN8O"};